import React, { useContext } from 'react';
import winnerDailyImg from './cards/winner_daily.png';
import winnerWeeklyImg from './cards/winner_weekly.png';
import winnerTournamentImg from './cards/winner_tournament.png';
import winnerBcsImg from './cards/winner_bcs.png';
import { dataContext } from '../../App';

export default function NewWinnerList({ setShowNewLeaderboardModal }) {
  const { setActiveLeaderboardName } = useContext(dataContext);

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding:'16px' }}>
        <img src={winnerDailyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_daily')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={winnerWeeklyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_weekly')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={winnerTournamentImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_tournament')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={winnerBcsImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_bcs')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
      </div>
    </>
  );
};
